import { DeleteOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { mapsAPI } from 'api/maps';
import { stationsAPI } from 'api/stations';
import { locationIcon } from 'assets/svg/location-icon';
import { DivIcon, LatLngLiteral as LatLngLiteralLeaflet } from 'leaflet';
import { useEffect, useState } from 'react';
import { Marker, Polyline, Popup, useMapEvents } from 'react-leaflet';

interface LatLngLiteral extends LatLngLiteralLeaflet {
  address?: string;
  station?: string;
}

interface EventListenerProps {
  initPosition?: LatLngLiteral;
  onClick: (value: LatLngLiteral) => void;
  isMulti?: boolean;
  initPositions?: Array<LatLngLiteral>;
  onClickMulti?: (value: Array<LatLngLiteral>) => void;
  color?: string;
  showSubmit?: boolean;
}

const MapEventListener = ({
  initPosition,
  onClick,
  isMulti,
  initPositions,
  onClickMulti,
  color,
  showSubmit,
}: EventListenerProps) => {
  const [position, setPosition] = useState<LatLngLiteral | undefined>(
    initPosition
  );
  const [arrPosition, setArrPosition] = useState<Array<LatLngLiteral>>(
    initPositions ?? []
  );

  const findStation = async ({ lat, lng }: LatLngLiteral) => {
    try {
      const { rows } = await stationsAPI.findAll({ lat: lat, lng: lng });
      if (rows.length > 0) {
        setArrPosition((prev) =>
          prev.map((position) => {
            if (position.lat === lat && position.lng === lng) {
              return {
                ...position,
                station: rows[0].title,
              };
            }

            return position;
          })
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const map = useMapEvents({
    click(e) {
      if (isMulti) {
        setArrPosition([
          ...arrPosition,
          {
            lat: e.latlng.lat,
            lng: e.latlng.lng,
          },
        ]);

        mapsAPI
          .findAddress({
            lat: e.latlng.lat,
            lng: e.latlng.lng,
          })
          .then((data) =>
            setArrPosition((prev) =>
              prev.map((position) => {
                if (
                  position.lat === e.latlng.lat &&
                  position.lng === e.latlng.lng
                ) {
                  findStation(position);

                  return {
                    ...position,
                    address: data.display_name,
                  };
                }

                return position;
              })
            )
          )
          .catch((error) => {
            console.log(error);
          });
      } else {
        setPosition(e.latlng);
        onClick(e.latlng);
      }

      map.flyTo(e.latlng, map.getZoom());
    },
  });

  useEffect(() => {
    if (onClickMulti) {
      onClickMulti(arrPosition);
    }
  }, [arrPosition]);

  if (isMulti) {
    return (
      <>
        {arrPosition.map((position, index) => (
          <Marker
            key={`position-${index}`}
            position={position}
            icon={
              new DivIcon({
                className: 'location-icon',
                html: locationIcon(color),
                iconSize: [40, 40],
              })
            }
          >
            <Popup className="">
              {showSubmit && (
                <div style={{ width: '100%' }}>
                  <Typography.Link
                    type="danger"
                    onClick={(e) => {
                      e.stopPropagation();
                      setArrPosition((prev) => {
                        const newArr = prev.filter(
                          (value) =>
                            value.lat !== position.lat &&
                            value.lng !== position.lng
                        );
                        onClickMulti?.(newArr);

                        return newArr;
                      });
                    }}
                  >
                    <DeleteOutlined />
                  </Typography.Link>
                </div>
              )}
              <Typography.Paragraph style={{ margin: 0 }}>
                {position?.address ?? ` Vị trí ${index + 1}`}
              </Typography.Paragraph>
              {position?.station && (
                <Typography.Paragraph>
                  Lý trình: {position?.station}
                </Typography.Paragraph>
              )}
            </Popup>
          </Marker>
        ))}
        {arrPosition.length > 0 && (
          <Polyline
            positions={arrPosition.map((position) => [
              position.lat,
              position.lng,
            ])}
            color={color}
          />
        )}
      </>
    );
  }

  return position ? (
    <Marker position={position!}>
      <Popup>Vị trí hiện tại</Popup>
    </Marker>
  ) : null;
};

export default MapEventListener;
